import OrderReviewHistoryBox from './src/main.js'

export default OrderReviewHistoryBox



// WEBPACK FOOTER //
// ./src/views/order-review/components/order-review-history-box/index.js